import React from 'react'
import Application from './Application'
import Section2 from './Section2'
import Section3 from './Section3'
import Section5 from './Section5'

const LocationApplication = () => {
  return (
    <div className='md:px-24 px-4'>
             <div>
        <h1 className='font-bold text-[10px] md:text-[36px] text-[#03897B]'>PURPOSE</h1>
      </div>

      {/* Image Container */}
      <div className="relative w-full h-[100px] md:h-[427px] rounded-t-[5px] overflow-hidden ">
        {/* Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014620/image_64_j0kpwn.png"
          alt="Funding"
          className="w-full h-full object-cover"
        />

        {/* Logo */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014742/image_1717_1_mrc5cr.png"
          alt="Ad Luck Logo"
          className="absolute bottom-6 left-4 md:bottom-12 md:left-8 w-[60px] md:w-[174px]"
        />
      </div>

      {/* Bottom Bar */}
      <div className="w-full h-[30px] md:h-[78px] bg-[#e0e0e0] flex items-center justify-between px-4 md:px-6 font-bold text-sm rounded-b-[5px]">
        <span className='text-[10px] md:text-[24px]'>FUNDING</span>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014605/Expand_right_13_khjlok.png"
          alt="Arrow"
          className="h-[26px] w-[26px] md:h-[46px] md:w-[47px]"
        />
      </div>

      <div className='md:mt-10 md:mb-14 mt-5 mb-6'>
        <p className='md:text-[18px] text-[8px] font-normal'>
        Ad-Luck positions itself as a trusted intermediary for development partners, streamlining the disbursement of funds to ensure they reach targeted beneficiaries efficiently, transparently, and with measurable impact on community development. <br/>
        Entrepreneurs can access funding from development partners by registering through the Ad-Luck Holdings funding portal. Once registered, their applications are evaluated for compliance with funding criteria. Those who meet the requirements are then eligible to receive financial support.
        </p>
      </div>
      <div className='flex items-center md:space-x-4'>
   <a href='/funding'>
   <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>DUE DILIGENCE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Due dilligence
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to  due diligence</p>

            </div>
   </a>
           <a href='/BusinessPlan'>
           <div>
      <p className='md:text-[20px] text-[8px]  font-bold md:mb-3'>BUSINESS PLANS</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Business plans
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to  business plans</p>

            </div>
           </a>
     <a href='/CreditScore'>
     <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>CREDIT SCORE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Credit score
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to credit score</p>

            </div>
     </a>
           <a href='/LocationApplication'>
           <div>
      <p className='md:text-[20px] text-[8px]   font-bold md:mb-3'>FUNDING</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Loan Application
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to Funding</p>

            </div>
           </a>
   </div>
   <div className='md:mt-1 mb-6 mt-5 md:mb-14'>
   <h1 className='md:text-[28px] text-[8px] font-bold md:mt-4'>FUNDING</h1>
        <p className='md:text-[18px] text-[6px] font-normal '>
        Ad-Luck’s funding application form serves as the initial step for entrepreneurs seeking financial support. It captures essential information about the applicant’s business, funding needs, and project goals, enabling a structured and efficient evaluation process.
        </p>
      </div>
      <Application/>

      <Section2/>
      <Section3/>
      <Section5/>
      <div className="flex justify-end md:mt-3 mt-4">
      
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
      <div className='flex gap-4 items-center md:mt-5'>
  <div
      className="md:w-16 md:h-[63px]  w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center"
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690778/Check_round_fill_ipswvy.png"
        alt="Check"
        className="md:w-[54px] md:h-[54px] w-[20px] h-[20px]"
      />
    </div>
    
    <p className="md:text-[20px]  text-[6px]">
        By ticking I confirm that I agree with the{" "}
        <span className="underline">Terms and conditions</span>, <span className='underline'>Data </span>and{" "}
        <span className="underline">Privacy policy</span>.
      </p>
  </div>
      {/* Register Button */}
      <button className="w-full bg-[#03897B] flex justify-center md:mt-10 mt-5 border-b-[3px] md:py-2 py-1 border-[#FDBD26] text-center md:h-[74px] h-[20px] text-white md:text-[36px] text-[6px] font-bold rounded-md">
      Submit
      </button>
         {/* Buttons */}
         <div className="flex md:gap-4 gap-1  justify-end md:mt-7 mt-2 md:mb-10 mb-5">
        {/* Edit Button */}
        <div>
        <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-8 px-4 ">
          <span>EDIT</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
            alt="Edit Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
        Edit registration form
        </p>
        </div>


        {/* Save Button */}
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SAVE</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Save registration 
        </p>
    </div>
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
      </div>
    </div>
  )
}

export default LocationApplication